module.exports = __webpack_public_path__ + "img/e_3_22_r.b7d7d2ef.png";